import { MDBDataTable } from "mdbreact"
import React, { useEffect, useRef, useState } from "react"
import MetaTags from "react-meta-tags"
import { Col, Container, Row, Alert } from "reactstrap"
import { Link } from "react-router-dom"

import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"

// services
import Admin from "../../services/admin/Admin"

const adminService = new Admin()

const ConsumptionAreas = () => {
  const [areas, setAreas] = useState([])
  const [modal, setModal] = useState(false)
  const [newAreaName, setNewAreaName] = useState("")

  useEffect(()=>{
    fetchConsumptionAreas();
  }, [])

  const toggleModal = () => {
    setModal(!modal)
  }

  const fetchConsumptionAreas = async () => {
    try {
      const response = await adminService.getConsumptionAreas()
      setAreas(response.data)
    } catch (error) {
      console.error("Error fetching data:", error)
    }
  }

  const addConsumptionArea = async () => {
    try {
      const response = await axios.post("your-api-endpoint-here", {
        name: newAreaName,
      })
      setNewAreaName("")
      toggleModal()
      // You can update the state with the new data if needed
      fetchConsumptionAreas()
    } catch (error) {
      console.error("Error adding consumption area:", error)
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Consumption Areas</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">Consumption Areas</div>
          <Row>
            <div>
              {/* At the time of writing, Admins cannot add new consumption areas. They can only add consumption area items */}
              {/* <Button color="primary" onClick={toggleModal}>
                Add New Consumption Area
              </Button> */}

              <Modal isOpen={modal} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>
                  Add New Consumption Area
                </ModalHeader>
                <ModalBody>
                  <input
                    type="text"
                    placeholder="Enter the name of the new consumption area"
                    value={newAreaName}
                    onChange={e => setNewAreaName(e.target.value)}
                  />
                </ModalBody>
                <ModalFooter>
                  <Button color="primary" onClick={addConsumptionArea}>
                    Add
                  </Button>{" "}
                  <Button color="secondary" onClick={toggleModal}>
                    Cancel
                  </Button>
                </ModalFooter>
              </Modal>

              <table className="table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Created At</th>
                    <td>View</td>
                  </tr>
                </thead>
                <tbody>
                  {areas.map((area, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{area.name}</td>
                      <td>{new Date(area.created_at).toLocaleString()}</td>
                      <td><a href={"consumption-items?id="+area.id}>View Items</a></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ConsumptionAreas
